

























































































import { computed, defineComponent } from '@vue/composition-api';
import { Routes } from '@front-app/constants/routes';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import BackButton from '@front-app/components/buttons/BackButton.vue';

export default defineComponent({
	components: {
		EditButton,
		CtaButton,
		BackButton,
		FontAwesomeIcon,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
		groupId: {
			type: String,
			default: '',
		},
		isPublished: Boolean,
		canEditEvent: Boolean,
		canManageEvent: Boolean,
		isAdministrationPage: Boolean,
	},
	setup(props) {
		const toEventAdministration = { name: Routes.EVENT_ADMIN_DETAILS, params: { eventId: props.eventId } };
		const toEventManagement = { name: Routes.EVENT_ADMIN_MANAGEMENT, params: { eventId: props.eventId } };
		const toEvent = computed(() => {
			if (props.groupId) {
				return { name: Routes.GROUP_EVENT, params: { eventId: props.eventId, groupId: props.groupId } };
			}
			return { name: Routes.EVENT, params: { eventId: props.eventId } };
		});

		return {
			toEventAdministration,
			toEventManagement,
			toEvent,
			// Util
			Size,
			Routes,
			ButtonPalettes,
		};
	},
});
